import React, {Fragment} from 'react';
import DataflowsList from "./List";
import {compose} from "redux";
import {translate} from 'react-i18next';
import DataflowDetail from "./Detail";
import DataflowPublishingListDataflowProductionModal from "./DataflowPublishingListDataflowProductionModal";
import DataflowDownload from "./DataflowDownload";

const Dataflows = () => {
    return (
        <Fragment>
            <DataflowsList/>
            <DataflowDetail/>
            <DataflowDownload />
            <DataflowPublishingListDataflowProductionModal/>
        </Fragment>
    )
};

export default compose(
    translate()
)(Dataflows);
